import Pikaday from 'pikaday/pikaday.js';
import moment from 'moment/moment.js';

export default class DatePicker {

    constructor() {
        // Date ranges
        this.dateFormat = 'DD-MM-YYYY';
        this.startDateEl = document.getElementsByName("start")[0];
        this.endDateEl = document.getElementsByName("end")[0];
        // some pages dont have the refinement filters
        if (this.endDateEl && this.startDateEl) {
            this.init();
        }
    }

    init() {
        let fromField = document.getElementById('datepickerFrom');
        let toField = document.getElementById('datepickerTo');
        
        let todaysDate = new Date();
        
        // Check if fields have value on load, and set start and end dates accordingly
        let startDate = null;
        if (fromField.value) {
            startDate = moment(fromField.value, this.dateFormat).toDate();
        }

        let endDate = null;
        if (toField.value) {
            endDate = moment(toField.value, this.dateFormat).toDate();
        }

        var fromPicker = new Pikaday({
            field: fromField,
            container: document.getElementById("calendarModalFrom"),
            defaultDate: startDate,
            setDefaultDate: Boolean(startDate),
            format: 'DD-MM-YYYY',
            maxDate: todaysDate,
            toString(date, format) {
                return moment(date).format('DD-MM-YYYY');
            },
            onOpen: function() {
                if (toField.value) {
                    // Set end date on open because Chrome aggressively caches JS
                    var toEndDate = moment(toField.value, 'DD-MM-YYYY').toDate();
                    fromPicker.setMaxDate(toEndDate);
                }
            },
            onSelect: function() {
                var selectedDate = new Date(this.getDate());
                var minEndDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
                toPicker.setMinDate(minEndDate);
                if (!toField.value && fromField.value) {
                    toPicker.setDate(todaysDate); // Changed this to today's date as this is the most likely desired result rather than just one day ahead
                }
            }
        });

        var toPicker = new Pikaday({
            field: toField,
            container: document.getElementById("calendarModalTo"),
            defaultDate: endDate,
            maxDate: todaysDate,
            minDate: startDate,
            setDefaultDate: true,
            format: 'DD-MM-YYYY',
            toString(date, format) {
                return moment(date).format('DD-MM-YYYY');
            },
            onOpen: function() {
                if (fromField.value) {
                    // Set start date on open because Chrome aggressively caches JS
                    var startDate = moment(fromField.value, 'DD-MM-YYYY').toDate();
                    toPicker.setMinDate(startDate);
                }
            },
            onSelect: function() {
                var selectedDate = new Date(this.getDate());
                var maxEndDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()); // Today
                fromPicker.setMaxDate(maxEndDate);
                var startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()-1 );
                if (!fromField.value && toField.value) {
                    fromPicker.setDate(startDate);
                }
            }
        });
    }
}